import React, { useEffect, useRef } from "react";
import "./ProjectPopover.css";

const ProjectPopover = ({ project, onClose }) => {
  const ref = useRef(null);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    function onClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [onClose]);

  if (!project) return null;

  return (
    <div className="project-popover-backdrop" role="dialog" aria-modal="true" aria-label={`${project.name} info`}>
      <div className="project-popover" ref={ref}>
        <button className="project-popover-close" onClick={onClose} aria-label="Close">×</button>
        <div className="project-popover-header">
          <div className="project-popover-avatar">{project.name.slice(0, 2).toUpperCase()}</div>
          <h3 className="project-popover-title">{project.name}</h3>
        </div>
        <div className="project-popover-body">
          <p>{project.description}</p>
        </div>
      </div>
    </div>
  );
};

export default ProjectPopover;